import React, { useState } from 'react'
import { useQuery } from 'react-query'

import { useAuthentication } from '@hooks/useAuthentication'
import { UserMissionEnum } from '@interfaces/UserMissionEnum'
import { useUserMissionAction } from '@hooks/userMission/useUserMissionAction'
import { UserMissionPageProps } from './interface'

export function withUserMissionPage(Component: React.FC<UserMissionPageProps>) {
  function Hoc() {
    const userMissionClient = useUserMissionAction()
    const { isAuthenticated } = useAuthentication()

    const [userMissionType, setUserMissionType] = useState<UserMissionEnum>(
      UserMissionEnum.READER
    )

    const { data = [], isLoading } = useQuery(
      ['my-user-mission', userMissionType],
      () => userMissionClient.getMyUserMission(userMissionType),
      {
        enabled: isAuthenticated,
      }
    )

    function handleUserMissionTypeChange(value: UserMissionEnum) {
      setUserMissionType(value)
    }

    const componentProps = {
      data,
      isLoading,
      userMissionType,
      handleUserMissionTypeChange,
    }

    return <Component {...componentProps} />
  }

  return Hoc
}
